"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
function default_1(event, prevState = {}) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const tables = (0, utils_1.getTablesFromOrder)(order);
    const updatedTables = event.tables.map(table => {
        var _a;
        const existingTable = tables === null || tables === void 0 ? void 0 : tables.find(t => t.id === table.tableId);
        return {
            id: table.tableId,
            name: table.tableName,
            guestCount: table.guestCount,
            status: (_a = existingTable === null || existingTable === void 0 ? void 0 : existingTable.status) !== null && _a !== void 0 ? _a : domain_1.TableStatus.SEATED,
            ...(table.sectionId && {
                section: {
                    id: table.sectionId,
                    name: table.sectionName,
                },
            }),
        };
    });
    order.tables = updatedTables;
    order.table = updatedTables[0];
    return order;
}
exports.default = default_1;
//# sourceMappingURL=assignTables.js.map